import { TranslationsInterface } from 'translations';

const en: TranslationsInterface = {
  'banner-cookie':
    'This website uses cookies to ensure its proper functioning and analyze traffic. By clicking "Accept all cookies", you are agreeing to the use of all our cookies. By clicking "Refuse non-essential cookies", you are rejecting optional cookies but allowing the use of our essential cookies. To check which cookies you are authorizing or rejecting, click on',
  'cookie-policy': 'Cookies Policy',
  'cookie-accept': 'Accept all cookies',
  'cookie-reject': 'Refuse non-essential cookies',
  'splash-window-1':
    'This portal provides access to information related to the communications sector.',
  'splash-window-2': 'For additional information, please consult the',
  help: 'Help section',
  close: 'Close',
  themes: 'THEMES',
  'turnoff-layers': 'Turn off layers',
  dock: 'Dock',
  undock: 'Undock',
  back: 'Back',
  'go-to': 'Go to',
  'no-data': 'No data available',
  compass: 'Reset map orientation',
  'my-location': 'My location',
  'help-menu': 'Help',
  'reset-map-orientation': 'Reset map orientation',

  // Coberturas disponíveis
  'fixed-network': 'Fixed network',
  'mobile-network': 'Mobile network',
  satellite: 'Satellite',
  operator: 'Operator',
  technology: 'Technology',
  'download-speed': 'Download (Mbps)',
  'upload-speed': 'Upload (Mbps)',
  'coverage-download': 'Coverage / Download (Mbps)',
  expand: 'Expand',
  collapse: 'Collapse',
  'fixa-msg':
    'In cases where service conditions are equivalent, operators are displayed in random order. For more information on available coverage, please refer to the "Help" section or {{LINK}}click here{{/LINK}}.',
  'movel-msg':
    'The information presented is supplied directly by the operators. In cases where service conditions are equivalent, operators are displayed in random order. For more information on available coverage, please refer to the "Help" section or {{LINK}}click here{{/LINK}}.',
  'satelite-msg':
    'The information presented is supplied directly by the operators. In cases where service conditions are equivalent, operators are displayed in random order. For more information on available coverage, please refer to the "Help" section or {{LINK}}click here{{/LINK}}.',
  'error-load-fixed-network': 'Unable to load fixed network results!',
  'error-load-mobile-network': 'Unable to load mobile network results!',
  'error-load-satellite': 'Unable to load satellite results!',

  // Aba identificar
  results: 'Results',
  buffer: 'Buffer',
  symbology: 'Symbology',
  zoom: 'Zoom',
  'select-all': 'Select all',
  'clear-id': 'Clear',
  'distance-meters': 'Distance (meters)',
  color: 'Color',
  transparency: 'Transparency',
  cancel: 'Cancel',
  apply: 'Apply',
  points: 'Points',
  lines: 'Lines',
  polygons: 'Polygons',
  polygon: 'Polygon',
  'access-here': 'Access here',
  size: 'Size',
  thickness: 'Thickness',
  outline: 'Outline',
  fill: 'Fill',

  // Aba pesquisar (há campos repetidos)

  search: 'Search',
  layer: 'Layer',
  field: 'Field',
  values: 'Values',
  'search-placeholder': 'Search...',
  'select-values-placeholder': 'Select values...',
  'fixed-distance': 'Fixed distance',
  'interactive-distance': 'Interactive distance',
  line: 'Line',
  distance: 'Distance',
  meters: 'meters',

  // Widget Modal labels
  'load-data': 'Load data',
  'add-layer': 'Add data',
  'heat-map': 'Heat map',
  'cluster-map': 'Cluster',
  tools: 'Tools',
  'available-coverage': 'Available coverage',
  'coverage-quota': 'Coverage quota',
  'property-quota': 'Property quota',
  'save-image': 'Save imagem',
  'search-by-drawing': 'Create area of influence',
  'advanced-search': 'Advanced search',
  'previous-view': 'Previous view',
  move: 'Move',
  edit: 'Edit',
  'map-name': 'Map name',
  type: 'Type',
  add: 'Add',
  'share-map': 'Share map',
  share: 'Share',
  url: 'URL',
  file: 'File',
  complaints: 'Complaints',
  indicators: 'Indicators',
  'access-and-services': 'Access and services',
  'next-view': 'Next view',
  'initial-view': 'Initial view',
  print: 'Print',
  'print-title': 'PRINT',
  'map-title': 'Map title',
  format: 'Format',
  'page-size': 'Page size',
  orientation: 'Orientation',
  'include-legend': 'Include legend',
  navigation: 'Navigation',
  'clear-section': 'Clear selection',
  sketch: 'Sketch',
  geoprocessing: 'Geoprocessing',
  measurement: 'Measurement',
  radius: 'Radius',
  kilometers: 'Kilometers',
  'register-element': 'Create register object',
  'convert-coordinate': 'Coordinates',
  'map-management': 'My maps',
  'print-map': 'Print',
  occurrence: 'Occurrence management',
  'register-event': 'Create event',
  announcements: 'Construction announcements',
  path: 'Trace path',
  notes: 'Notes',
  'identify-results': 'Results',

  // Widget Modal Log labels
  identify: 'Identify',

  // Widget Map labels
  scales: 'Scales',
  coordinates: 'Coordinates',
  overview: 'Overview',
  'coordinates-list': 'Coordinates list',
  display: 'Display',
  'projected-coordinates-list': 'Projected coordinates list',
  project: 'Project',
  'enter-coordinates': `Enter coordinates below, one per line, in the format (Y,X):
  39.075690, -8.997064
  41.258176, -8.030267`,
  get: 'Get',

  // Tool Map labels
  'current-location': 'Current location',
  'street-view': 'Street view',
  'zoom-by-window': 'Zoom by window',
  fullscreen: 'Fullscreen',
  rotation: 'Move',
  'share-link': 'Share map',

  // Tool Map Action labels
  'zoom-in': 'Zoom in',
  'zoom-out': 'Zoom out',
  'initial-viewpoint': 'Initial viewpoint',
  'previous-viewpoint': 'Previous viewpoint',
  'next-viewpoint': 'Next viewpoint',
  clear: 'Clear selection',
  screenshot: 'Save image',

  //Medir
  measure: 'Measure',
  'square-meters': 'Square meters',
  'square-kilometers': 'Square kilometers',

  //Geoprocessamento
  concentration: 'Concentration',
  aggregation: 'Aggregation',

  point: 'Point',
  polyline: 'Polyline',
  'freehand-polyline': 'Freehand Polyline',
  arrow: 'Arrow',
  triangle: 'Triangle',
  rectangle: 'Rectangle',
  circle: 'Circle',
  ellipse: 'Ellipse',
  'freehand-polygon': 'Freehand Polygon',
  text: 'Text',

  // TOC
  'base-maps': 'Base Maps',
  'spectrum-planning-and-management': 'Spectrum Planning and Management',
  'spectrum-monitoring-and-supervision': 'Spectrum Monitoring and Supervision',
  coverage: 'Coverage (Fixed, Mobile and Satellite)',
  'postal-services': 'Postal Services (Universal Service Obligation – USO)',
  'statistics-and-market-analysis': 'Statistics and Market Analysis',
  infrastructures: 'Infrastructures',
  'general-themes': 'General Themes',
  'external-layers': 'External Layers',

  // Editar - anotações || Edit - Sketch
  'sketch-type': 'Sketch type',
  'point-type': 'Point Type',
  'point-color': 'Point Color',
  'point-size': 'Point Size',
  'outline-color': 'Outline Color',
  'outline-thickness': 'Outline Thickness',
  'line-type': 'Line Type',
  'fill-color': 'Fill Color',
  'text-size': 'Text Size',
  'text-color': 'Text Color',
  draw: 'Draw',
  'delete-all': 'Delete All',
  delete: 'Delete',
  square: 'Square',
  diamond: 'Diamond',
  cross: 'Cross',
  solid: 'Solid',
  dash: 'Dash',
  dot: 'Dot',
  'dash-dot': 'Dash-dot',
  'long-dash-dot-dot': 'Long-dash-dot-dot',
  'line-color': 'Line Color',
  'drop-or-browse': 'Drop or browse',
  'supported-file-formats': 'Supported file formats',

  // Mensagens
  'failed-load-location': 'Unable to load current location!',
  'select-location': 'Select the location on the map',
  warning: 'Warning',
  'select-location-or-enter-address':
    'Select a location on the map or enter your address in “Go to”.',
  'failed-load-data': 'Failed to load data!',
  'failed-load-page': 'Failed to load page!',
  'not-authenticated': 'Not authenticated!',
  'failed-generate-link': 'Failed to generate link',
  'failed-load-WKID-list': 'Failed to load WKID list!',
  'failed-load-favorite-map': 'Failed to load favorite map!',
  'map-not-found': 'Map not found!',
  'failed-load-map': 'Failed to load map!',
  'failed-export-image': 'Failed to export image',
  'failed-upload-file': 'Failed to upload file!',
  'layer-added-successfully': 'Layer added successfully',
  'failed-load-layer': 'Failed to load layer!',
  'no-route-found': 'No route found',
  'unable-calculate-routes': 'Unable to calculate routes!',
  'invalid-coordinates': 'Invalid coordinates!',
  'failed-project-coordinates': 'Failed to project coordinates!',
  'fill-required-fields-correctly':
    'Please fill in all required fields correctly!',
  'event-saved-successfully': 'Event saved successfully',
  'failed-save-event': 'Failed to save event!',
  'upload-completed-successfully': 'Upload completed successfully',
  'no-records-found': 'No records found',
  'failed-fetch-data': 'Failed to fetch data!',
  'export-large-items':
    'To export large extents, areas, or high number of selected features, contact the GIS team',
  'failed-export-data': 'Failed to export data!',
  'failed-load-attachments': 'Failed to load attachments!',
  'unable-retrieve-current-location': 'Unable to retrieve current location!',
  'process-created-successfully': 'Process created successfully',
  'failed-create-process': 'Failed to create process!',
  'only-zip-allowed': 'Only .zip files are allowed!',
  'uploaded-successfully': 'uploaded successfully',
  'failed-read-file': 'Failed to read file!',
  'map-loaded-successfully': 'Map loaded successfully',
  'map-shared-successfully': 'Map shared successfully',
  'failed-share-map': 'Failed to share map!',
  'map-imported-successfully': 'Map imported successfully',
  'failed-import-map': 'Failed to import map!',
  map: 'Map',
  'marked-favorite-successfully': 'marked as favorite successfully',
  'failed-to': 'Failed to',
  'mark-map-as-favorite': 'mark map as favorite!',
  'map-deleted-successfully': 'Map deleted successfully',
  'failed-delete-record': 'Failed to delete record!',
  'map-saved-successfully': 'Map saved successfully',
  'failed-save-data': 'Failed to save data!',
  'failed-download-attachment': 'Failed to download attachment!',
  'failed-load-incident-statuses': 'Failed to load incident statuses!',
  'failed-load-incident-types': 'Failed to load incident types!',
  'incident-status-updated-successfully':
    'Incident status updated successfully!',
  'failed-update-incident-status': 'Failed to update incident status!',
  'select-area': 'Select an area!',
  'incident-saved-successfully': 'Incident saved successfully',
  'failed-save-incident': 'Failed to save incident!',
  'failed-load-entities': 'Failed to load entities!',
  'failed-fetch-incident-data': 'Failed to fetch incident data!',
  'failed-load-results': 'Failed to load results!',
  'printing-failed': 'Printing failed, please try again!',
  'data-saved-successfully': 'Data saved successfully',
  'no-features-found': 'No features found',
  'filter-deleted-successfully': 'Filter deleted successfully',
  'failed-delete-history-filter': 'Failed to delete history filter!',
  'failed-load-history': 'Failed to load history!',
  'failed-load-documents': 'Failed to load documents!',
  'search-saved-successfully': 'Search saved successfully',
  'failed-save-search': 'Failed to save search!',
  'link-copied-clipboard': 'Link copied to clipboard',
  'map-link-generated-successfully': 'Map link generated successfully',
  'unable-access-data': 'Unable to access data',
  'you-are-not-authenticated': 'You are not authenticated!',
  sucess: 'Success',
  error: 'Error',
  alert: 'Alert',
  'light-gray-canvas': 'Light Gray Canvas',
  'dark-gray-canvas': 'Dark Gray Canvas',
  'imagery-hybrid': 'Imagery Hybrid',
  'national-geographic-map': 'National Geographic Map',
  'navigation-map': 'Navigation',
  oceans: 'Oceans',
  streets: 'Streets',
  'terrain-with-labels': 'Terrain with Labels',
  topographic: 'Topographic',
  example: 'example',
  copy: 'Copy',
  includeNull: 'Include null values',
};

export default en;
